import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/find.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3531ff1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-paper-box" }
const _hoisted_2 = { class: "m-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wrong-image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "wrong-tip" }, "咦～智能搜题罢工啦，快来点醒他", -1))
const _hoisted_5 = {
  key: 2,
  class: "m-paper-info"
}
const _hoisted_6 = {
  class: "m-question-wrap",
  ref: "swipWrap"
}
const _hoisted_7 = {
  key: 0,
  ref: "swipeBox"
}
const _hoisted_8 = { class: "progress-group u-top m-section-title" }
const _hoisted_9 = { class: "number-tip" }
const _hoisted_10 = { class: "current" }
const _hoisted_11 = {
  key: 0,
  class: "m-footer"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-seperator-bar" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "m-button-wrap"
}
const _hoisted_14 = {
  key: 3,
  class: "m-paper-info m-flex-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, "暂无试题", -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_action_bar = _resolveComponent("new-action-bar")!
  const _component_loading_page = _resolveComponent("loading-page")!
  const _component_new_wrong_page = _resolveComponent("new-wrong-page")!
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!
  const _component_exercise_report = _resolveComponent("exercise-report")!
  const _component_QuesAnalysis = _resolveComponent("QuesAnalysis")!
  const _component_answer_sheet = _resolveComponent("answer-sheet")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_new_action_bar, {
        class: "m-action-bar",
        onGoBack: $setup.goBack,
        needShare: false,
        actionBarInfo: $setup.actionBarInfo
      }, null, 8, ["onGoBack", "actionBarInfo"]), [
        [_vShow, !$setup.showAnswerAnalysis && !$setup.showAnswerReport]
      ]),
      ($setup.pageLoading && !$setup.showWrongPage)
        ? (_openBlock(), _createBlock(_component_loading_page, {
            key: 0,
            progress: $setup.loadingProgress
          }, null, 8, ["progress"]))
        : _createCommentVNode("", true),
      ($setup.showWrongPage && !$setup.pageLoading)
        ? (_openBlock(), _createBlock(_component_new_wrong_page, {
            key: 1,
            class: "wrong-page-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", {
                class: "refresh-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.queryPaperInfo && $setup.queryPaperInfo(...args)))
              }, "点击重新获取")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!$setup.showWrongPage && !$setup.pageLoading && $setup.questionList?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ($setup.paperConfiged)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_van_progress, {
                        "stroke-width": 8,
                        percentage: (($setup.currentIndex + 1) / $setup.questionList.length) * 100,
                        "show-pivot": false,
                        class: "progress"
                      }, null, 8, ["percentage"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.currentIndex + 1), 1),
                        _createElementVNode("span", null, "/" + _toDisplayString($setup.questionList.length), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionList, (question, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(_component_question_detail, {
                          showTotal: false,
                          questionIndex: index,
                          retryNum: $setup.retryNum,
                          questionData: { list: question, total: $setup.questionList.length }
                        }, null, 8, ["questionIndex", "retryNum", "questionData"])
                      ], 512)), [
                        [_vShow, $setup.currentIndex === index]
                      ])
                    }), 128))
                  ], 512))
                : _createCommentVNode("", true)
            ], 512),
            ($setup.questionList?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  ($setup.swipeBox)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "u-card-icon-tile analysis",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleShowAnswerAnalysis && $setup.handleShowAnswerAnalysis(...args)))
                        }, "解析"),
                        _createElementVNode("div", {
                          class: "u-card-icon-tile card",
                          onClick: _cache[2] || (_cache[2] = () => $setup.showAnswerSheet(false))
                        }, "答题卡"),
                        _createElementVNode("div", {
                          class: _normalizeClass(["u-button-tile", { disabled: !$setup.currentIndex }]),
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handlePrev && $setup.handlePrev(...args)))
                        }, " 上一题 ", 2),
                        ($setup.currentIndex !== $setup.paperInfo.length - 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "u-button-tile",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleNext && $setup.handleNext(...args)))
                            }, " 下一题 "))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "u-button-tile",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.validHasUnAnswer('current')))
                            }, "确认提交"))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!$setup.showWrongPage && !$setup.pageLoading && !$setup.questionList?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
        : _createCommentVNode("", true),
      _createVNode(_component_aio_confirm, {
        visible: $setup.confirmVisible,
        confirmInfo: $setup.confirmInfo
      }, null, 8, ["visible", "confirmInfo"])
    ]),
    ($setup.showAnswerReport)
      ? (_openBlock(), _createBlock(_component_exercise_report, {
          key: 0,
          onDoRetry: $setup.doRetry,
          submitQestionMap: $setup.submitQestionMap,
          sourceLocation: "itembank"
        }, null, 8, ["onDoRetry", "submitQestionMap"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_QuesAnalysis, {
        onClose: $setup.closeAnalysis,
        index: $setup.currentIndex,
        sourceLocation: "itembank"
      }, null, 8, ["onClose", "index"])
    ], 512), [
      [_vShow, $setup.showAnswerAnalysis]
    ]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.answerSheetVisible,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.answerSheetVisible) = $event))
    }, {
      default: _withCtx(() => [
        ($setup.answerSheetVisible)
          ? (_openBlock(), _createBlock(_component_answer_sheet, {
              key: 0,
              onHandleTargetTile: $setup.handleTargetTile,
              onHandleSubmit: $setup.validHasUnAnswer,
              onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.answerSheetVisible = false)),
              "question-list": $setup.queResList,
              unAnsweredNum: 0,
              showButton: $setup.showButton,
              isAllDecidable: false
            }, null, 8, ["onHandleTargetTile", "onHandleSubmit", "question-list", "showButton"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}